import { render, staticRenderFns } from "./DataStream.vue?vue&type=template&id=8c7b9068&scoped=true&"
import script from "./DataStream.vue?vue&type=script&lang=ts&"
export * from "./DataStream.vue?vue&type=script&lang=ts&"
import style0 from "./DataStream.vue?vue&type=style&index=0&id=8c7b9068&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c7b9068",
  null
  
)

export default component.exports